import { Config } from "@config";
import { http } from "bm-ui-kit";
import type {
	SzechenyiAvailableLoansWithMaxAmounts,
	SzechenyiCalcRequest,
	SzechenyiLeadRequest,
	SzechenyiLoanType,
} from "./types";

export const SZECHENYI_LOAN_NAMES: Record<SzechenyiLoanType, string> = {
	SZECHENYI_KARTYA_HITEL_MAX: "Széchenyi Kártya Folyószámlahitel MAX+",
	SZECHENYI_LIKVIDITASI_HITEL_MAX: "Széchenyi Likviditási Hitel MAX+",
	SZECHENYI_BERUHAZASI_HITEL_MAX: "Széchenyi Beruházási Hitel MAX+",
	AGRAR_SZECHENYI_BERUHAZASI_HITEL_MAX: "Agrár Széchenyi Beruházási Hitel MAX+",
	AGRAR_SZECHENYI_KARTYA: "Agrár Széchenyi Kártya",
	AGRAR_SZECHENYI_KARTYA_MAX: "Agrár Széchenyi Kártya MAX+",
	SZECHENYI_TURISZTIKAI_KARTYA_MAX: "Széchenyi Turisztikai Kártya MAX+",
};

function getSzechenyiCalcRequest(data: SzechenyiLeadRequest): SzechenyiCalcRequest {
	return {
		lastYearIncome: data.taxBaseRevenue || data.netIncome,
		loanGoal: data.loanGoal,
		numberOfClosedYears: data.numberOfClosedYears,
		companySector: data.companySector,
	};
}

export async function calculateSzechenyiLoans(
	data: SzechenyiLeadRequest,
): Promise<SzechenyiAvailableLoansWithMaxAmounts> {
	const calcRequest = getSzechenyiCalcRequest(data);

	return http.post(Config.getApiUrl("/api/szechenyi-loan/calc"), calcRequest);
}

export function validTaxNumber(value: string): string {
	let taxNumber = value;

	// Tagolás ha nincs
	if (taxNumber.length === 11) {
		taxNumber = `${taxNumber.substr(0, 8)}-${taxNumber.substr(7, 1)}-${taxNumber.substr(9)}`;
	}
	const taxParts = taxNumber.split("-");

	// Hossz ellenőrzés
	if (taxNumber.length < 13) {
		return "A megadott adószám túl rövid!";
	}

	if (taxNumber.length > 13) {
		return "A megadott adószám túl hosszú!";
	}

	// Formátum ellenőrzés
	if (taxParts.length !== 3 || taxParts[0].length !== 8 || taxParts[1].length !== 1 || taxParts[2].length !== 2) {
		return "Érvénytelen adószám formátum (xxxxxxxx-y-zz)!";
	}

	// CDV ellenőrzés
	const multi = [9, 7, 3, 1, 9, 7, 3];
	let checksum = 0;
	for (let i = 0; i < 7; i++) {
		checksum += Number(taxParts[0][i]) * multi[i];
	}

	checksum %= 10;

	if (checksum > 0) {
		checksum = 10 - checksum;
	}

	if (Number(taxParts[0][7]) !== checksum) {
		return "Hibás adószám!";
	}

	// Típus ellenőrzés
	const type = Number(taxParts[1]);

	if (type < 1 || type > 5) {
		return "Érvénytelen adószám!";
	}

	// Régió ellenőrzés
	const regio = Number(taxParts[2]);

	if (!(((regio > 1 && regio < 45) || regio === 51) && regio !== 21)) {
		return "Érvénytelen adószám!";
	}
}
